import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. The service",
    body: "LyPinn Pulse, powered by LyPinn, provides realtime audience sentiment intelligence for physical venues — malls, events, parks, public sights, transit hubs, colleges and universities. The service comprises PulsePoint print touchpoints, PulseScreen kiosk touchpoints, and the Command Centre dashboard, which presents anonymised, aggregated sentiment signals collected from people physically present at your venue.",
  },
  {
    title: "2. Accounts",
    body: "You must provide accurate business information when creating an account, including your entity name, category and Command Centre display name. You are responsible for activity under your account and for keeping your credentials confidential. One account per venue or entity unless agreed otherwise in writing.",
  },
  {
    title: "3. Data & privacy",
    body: "All sentiment data is first-party and collected with audience consent at the point of interaction. Signals are anonymised by default: no names, precise identities or personal profiles are attached to individual responses. You receive aggregated, location-verified data points for your venue only. You may not attempt to re-identify individual respondents.",
  },
  {
    title: "4. Campaigns, pricing & payment",
    body: "Each campaign is priced from a one-time setup fee, the volume of expected interactions, the number of touchpoint channels and the analysis duration, as quoted during onboarding. Payment is charged once, in advance, via our payment processor. Quotes are valid at the time of checkout. Campaigns activate upon confirmed payment.",
  },
  {
    title: "5. Licence & acceptable use",
    body: "PulsePoint print kits, PulseScreen configurations and access to the Command Centre are licensed to you for the duration of your active campaign. You may deploy touchpoints only at venues you own, operate or are authorised to manage. You may not resell access, scrape the service, or use the data for unlawful surveillance or discrimination.",
  },
  {
    title: "6. Availability & changes",
    body: "We aim for continuous availability but do not guarantee uninterrupted service. Features may evolve as LyPinn Pulse improves; material changes affecting an active campaign will be communicated in advance.",
  },
  {
    title: "7. Liability",
    body: "Sentiment intelligence informs decisions but does not guarantee outcomes. To the maximum extent permitted by law, our aggregate liability is limited to the amount paid for the campaign in question.",
  },
  {
    title: "8. Contact",
    body: "Questions about these terms or the service: contact-pulse@lypinn.com. LyPinn Pulse is powered by LyPinn, built with love in Ahmedabad, India.",
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#050505] grid-lines" data-testid="terms-page">
      <div className="max-w-[900px] mx-auto px-6 py-20">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-mono-tech text-[11px] tracking-[0.2em] text-zinc-500 hover:text-[#E5FF00] transition-colors mb-12"
          data-testid="terms-back-link"
        >
          <ArrowLeft size={14} /> BACK TO LYPINN PULSE
        </Link>
        <p className="font-mono-tech text-[11px] tracking-[0.3em] text-[#E5FF00] mb-4">LEGAL</p>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mb-4" data-testid="terms-title">
          Terms &amp; Conditions
        </h1>
        <p className="text-zinc-500 text-sm mb-14">Last updated: August 2026 · Applies to LyPinn Pulse business accounts and campaigns.</p>
        <div className="space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title} className="border-l-2 border-white/10 pl-6 hover:border-[#E5FF00]/50 transition-colors duration-300">
              <h2 className="font-display font-bold text-xl mb-3">{s.title}</h2>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
